module.exports = "/build/web/svg/de-club-light.34d7cd54788f56225eb93af849cd739d.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/de-club-light.svg
// module id = 152
// module chunks = 24